import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { toast } from "react-toastify";
import { getAuthCookie } from "../../utils/authCookies";
// import "react-toastify/dist/ReactToastify.css";

type RotationalType = {
  id: string;
  name: string;
  count: number;
  status: string;
};

const SignageRotationalTypes = () => {
  const [rotationaltypes, setRotationalTypes] = useState<RotationalType[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null); // Track deletion in progress
  const token = getAuthCookie("sessionToken");

  const [toastShown, setToastShown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRotationalTypes = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/rotational-product-types`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setRotationalTypes(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRotationalTypes();
  }, [token]);

  // if (rotationaltypes?.length === 0) {
  //   return <div>Loading...</div>;
  // }

  useEffect(() => {
    if(rotationaltypes!=null && rotationaltypes?.length > 0) {
      const table = $("#transactions").DataTable({
        responsive: false,
        destroy: true,
        lengthChange: false,
        ordering: false,
      });

      return () => {
        table.destroy();
      };
    }
  }, [rotationaltypes]);

  const handleDelete = async (rotationaltypeId: string) => {

    setDeleting(rotationaltypeId); // Set the license being deleted

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/rotational-product-types/${rotationaltypeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete the rotationaltype.");
      }

      toast.success("RotationalType deleted successfully!");
      // Update the state by removing the deleted license
      setRotationalTypes((prev) =>
        prev.filter((group) => group.id !== rotationaltypeId)
      );
      setDeleting(null); // Clear the deleting state
      navigate(0);
    } catch (err) {
      toast.error("Failed to delete the rotationaltype.");
      setError(
        err instanceof Error
          ? err.message
          : "An unknown error occurred while deleting."
      );
      setDeleting(null); // Clear the deleting state
    }
  };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Rotational Types </h2>
          <div className="text-end">
            <Link
              to="/signage/addRotationalType"
              className="btn btn-primary float-right"
            >
              Add Rotational Type
            </Link>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="table-container">
                    <table
                      id="transactions"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle w-100"
                    >
                      <thead>
                        <tr>
                          <th>S.No.</th>                          
                          <th>Name</th>
                          <th>Count</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rotationaltypes != null &&
                          rotationaltypes?.map((rotationaltype, index) => (
                            <tr key={index}>                              
                              <td>{index + 1}</td>   
                              <td>{rotationaltype.name}</td>
                              <td>{rotationaltype.count}</td>
                              <td>
                                {rotationaltype.status ? "Active" : "Inactive"}
                              </td>
                              <td>
                                <Link
                                  to={`/signage/editRotationalType/${rotationaltype.id}`}
                                  className="btn btn-warning waves-effect waves-light me-2 btn-sm"
                                >
                                  <i className="ri-pencil-fill align-bottom"></i>
                                </Link>

                                <button
                                  onClick={() =>
                                    window.confirm(
                                      "Are you sure you want to delete this rotationaltype?"
                                    ) && handleDelete(rotationaltype.id)
                                  }
                                  className="btn btn-danger waves-effect waves-light btn-sm"
                                >
                                  <i className="ri-delete-bin-fill align-bottom"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignageRotationalTypes;
